import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const BhutanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_14356'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_14356)'>
				<rect
					width='20'
					height='14'
					fill='#FF5F38'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14L20 0H0V14Z'
					fill='#FFD951'
				/>
			</g>
		</svg>
	);
};

export default BhutanFlagIcon;
